<template>
<div id="forgot-password">
  <div class="container">
    <div class="jumbotron">
      <div class="row">
        <div class="col-md-offset-3 col-md-6 text-center">
          <h1>SPIADI</h1>
          <p>
            Surveillance et Prévention des Infections Associées
            aux Dispositifs Invasifs
          </p>
        </div>
      </div>
    </div>
    <user-info
      title="Changement de mot de passe"
      :subtitles="[`Veuillez saisir les nom, prénom et adresse e-mail
                  associés à votre compte.`,
                  `Un e-mail vous sera envoyé avec un lien pour réinitialiser
                  votre mot de passe.`]"
      defaultError="Vérifiez vos nom, prénom et adresse e-mail
                    avant de réessayer. Si cette erreur persiste, contactez
                    nous en utilisant le lien ci-dessous :"
      source="forgot" />
  </div>
</div>
</template>
<script>
import userinfo from '@/sui/components/userInfo'
export default {
  name: 'forgot-password',
  components: {
    'user-info': userinfo
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#forgot-password {
    min-height: 100%;
    background-color: @base;

    .jumbotron {
        margin-bottom: 0rem;
    }

    #login-button {
        margin-bottom: 1rem;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
}
</style>
